import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router'; 

@Component({
  selector: 'app-accounts-dashboard',
  standalone: true,
  imports: [CommonModule, RouterLink], 
  templateUrl: './accounts-dashboard.component.html',
  styleUrls: ['./accounts-dashboard.component.css']
})
export class AccountsDashboardComponent {
  
 
  downloadReport(reportName: string) {
    alert(`Downloading ${reportName}...`);
  }


  sendReminder(partyName: string) {
    alert(`🔔 Payment Reminder sent to ${partyName}`);
  }
}